import React from 'react';
import { Switch } from 'antd';

export const Toggle = ({
    toggleText,
    toggleTextClassName,
    className,
    checked,
    onChange,
    disabled,
    title,
}) => {
    return (
        <>
            <div
                className={`flex items-center w-full ${
                    className ? className : ''
                }`}
            >
                <div className={toggleTextClassName}>{toggleText}</div>
                <div>
                    <Switch
                        checked={checked}
                        onChange={onChange}
                        disabled={disabled}
                        title={title}
                    />
                </div>
            </div>
        </>
    );
};

Toggle.defaultProps = {
    toggleTextClassName: 'w-1/4 font-semibold text-texts-tertiary',
};
